module.exports = __webpack_public_path__ + "static/media/dsb-SPIRITS.9fab2072.jpg";